const mixin = {
  computed: {
    $usuarioAdministrador(){
      return this.$user && this.$user.roles?.some(r => 'ADMINISTRADOR' === r.toUpperCase());
    },
    $usuarioGgeiai(){
      return this.$user && this.$user.roles?.some(r => 'GGEIAI' === r.toUpperCase());
    },
    $usuarioArticuladorRegional(){
      return this.$user && this.$user.roles?.some(r => 'ARTICULADOR REGIONAL' === r.toUpperCase());
    },
  }
};

export default mixin;